export const config = {
    entityKey: 'messages',
    titles: {
        singular: 'Message',
        plural: 'Messages'
    }
}